import { render, staticRenderFns } from "./vehiclePosition.vue?vue&type=template&id=0c8d7d9c&scoped=true"
import script from "./vehiclePosition.vue?vue&type=script&lang=js"
export * from "./vehiclePosition.vue?vue&type=script&lang=js"
import style0 from "./vehiclePosition.vue?vue&type=style&index=0&id=0c8d7d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d7d9c",
  null
  
)

export default component.exports